import type { SubscribersAnalysisData } from '@/modules/tracking/new-subscriber-analysis/types.ts'
import { apiClient } from '@/utils/axios.ts'
import { dateToString } from '@/utils/helpers.ts'

export const getSubscribersAnalysis = async (
  creatorId: number,
  from: Date,
  to: Date,
  signal: AbortSignal | undefined,
): Promise<SubscribersAnalysisData> => {
  const params = {
    from: dateToString(from),
    to: dateToString(to),
  }
  const response = await apiClient.get(
    `/new-subscriber/statistic/${creatorId}`,
    {
      params,
      signal,
    },
  )

  return response.data
}
